import FontFactory from './FontFactory';

const preloadFont = async (family: string, url: string) => {
  document.fonts.add(await FontFactory.createFont(family, `url(${url})`).load());
};

export default preloadFont;
